// removed by extract-text-webpack-plugin
module.exports = {"cartPage":"cartPage__2NcJv","cartPage_title":"cartPage_title__32FD4"};


//////////////////
// WEBPACK FOOTER
// ./components/Cart/CartPage.scss
// module id = SvzN
// module chunks = 0